<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <div class="presentation-page__impression presentation-page__impression--bleed">
        <div
          class="presentation-page__impression-text presentation-page__impression-text--centered"
        >
          <div class="presentation-page__impression-text-inner">
            <p class="presentation-page__eyebrow">Impressionen</p>
            <h2 class="presentation-page__headline">B2B</h2>
            <div class="presentation-page__accent-line" aria-hidden="true"></div>
            <p class="presentation-page__text">
              Gewerbe-, Industrie- und Logistikdächer ab 100 kWp. EPC-Komplettleistung mit eigenen
              Teams und bankfähiger Dokumentation.
            </p>
          </div>
        </div>
        <div class="presentation-page__impression-media">
          <img
            class="presentation-page__image presentation-page__impression-image"
            src="/img/master_presentation/master_presentation_page_22.png"
            alt="Großflächige Photovoltaikanlage auf einem Gewerbe- oder Industriedach"
          />
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage22',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
};
</script>
